export default "__VITE_ASSET__BPu6pees__"